<template>
  <Field :name="name" :id="name" :rules="rules" v-slot="{ field, errors, errorMessage, meta }">
    <input v-bind="field" :type="type" :placeholder="placeholder" class="form-control"
      :class="{ 'is-invalid': !!errors.length, 'is-valid': meta.valid && meta.dirty }" :disabled="disabled"
      :aria-label="placeholder" ref="input" :min="min" :step="step" />
    <span class="invalid-feedback" v-if="!!errors.length">{{ errorMessage }}</span>
  </Field>
</template>

<script>
import { Field } from "vee-validate";

export default {
  name: "BootstrapField",
  props: ["name", "placeholder", "rules", "type", "as", "disabled", "min", "step"],
  components: {
    Field
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    }
  }
}
</script>

<style scoped></style>